import { WorshipReport } from '../types/worshipReport';
import { FinanceReport } from '../types/financeReport';
import { utils, writeFile } from 'xlsx';

function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('fr-FR');
}

export function exportToXLSX(worshipReports: WorshipReport[], financeReports: FinanceReport[], startDate: string, endDate: string) {
  // Filter worship reports based on date range
  const start = new Date(startDate + 'T00:00:00.000Z');
  const end = new Date(endDate);
  end.setUTCHours(23, 59, 59, 999);

  const filteredWorshipReports = worshipReports.filter(report => {
    const reportDate = new Date(report.date);
    reportDate.setUTCHours(0, 0, 0, 0);
    return reportDate >= start && reportDate <= end;
  });

  // Filter finance reports based on date range
  const filteredFinanceReports = financeReports.filter(report => {
    const reportDate = new Date(report.date);
    reportDate.setUTCHours(0, 0, 0, 0);
    return reportDate >= start && reportDate <= end;
  });

  // Prepare worship data for Excel
  const worshipData = filteredWorshipReports.map(report => ({
    'Date': formatDate(report.date),
    'Adultes - Hommes': report.attendance.adults.men,
    'Adultes - Femmes': report.attendance.adults.women,
    'Boss - Hommes': report.attendance.served.men,
    'Boss - Femmes': report.attendance.served.women,
    'Enfants - Garçons': report.attendance.children.boys,
    'Enfants - Filles': report.attendance.children.girls,
    'Blooms': report.attendance.blooms,
    'Nouveaux Hommes': report.newMembers.men,
    'Nouvelles Femmes': report.newMembers.women,
    'Nouveaux Blooms': report.newMembers.blooms,
    'Nouveaux Enfants': report.newMembers.children,
    'Total': report.totalParticipants
  }));

  // Prepare finance data for Excel
  const financeData = filteredFinanceReports.map(report => ({
    'Date': formatDate(report.date),
    'Dîmes': report.finances.tithes,
    'Offrandes Ordinaires': report.finances.regularOfferings,
    'Offrandes Spéciales': report.finances.specialOfferings,
    'Total Finances': report.totalFinances
  }));

  // Create workbook and worksheet
  const wb = utils.book_new();
  
  // Create worship reports sheet
  const wsWorship = utils.json_to_sheet(worshipData);

  // Set column widths
  const worshipColWidths = [
    { wch: 12 },  // Date
    { wch: 15 },  // Adultes - Hommes
    { wch: 15 },  // Adultes - Femmes
    { wch: 15 },  // Boss - Hommes
    { wch: 15 },  // Boss - Femmes
    { wch: 15 },  // Enfants - Garçons
    { wch: 15 },  // Enfants - Filles
    { wch: 10 },  // Blooms
    { wch: 15 },  // Nouveaux Hommes
    { wch: 15 },  // Nouvelles Femmes
    { wch: 15 },  // Nouveaux Blooms
    { wch: 15 },  // Nouveaux Enfants
    { wch: 10 },  // Total
  ];
  wsWorship['!cols'] = worshipColWidths;

  // Create finance reports sheet
  const wsFinance = utils.json_to_sheet(financeData);
  const financeColWidths = [
    { wch: 12 },  // Date
    { wch: 15 },  // Dîmes
    { wch: 20 },  // Offrandes Ordinaires
    { wch: 20 },  // Offrandes Spéciales
    { wch: 15 },  // Total Finances
  ];
  wsFinance['!cols'] = financeColWidths;

  // Add the worksheets to the workbook
  utils.book_append_sheet(wb, wsWorship, 'Rapports Culte');
  utils.book_append_sheet(wb, wsFinance, 'Rapports Finance');

  // Format dates for filename
  const formattedStartDate = startDate.replace(/-/g, '');
  const formattedEndDate = endDate.replace(/-/g, '');

  // Generate and download the file
  writeFile(wb, `rapports_complets_${formattedStartDate}_${formattedEndDate}.xlsx`);
}